// Module
var code = "<div> <h3 class=\"toggle-header primary-heading\" ng-click=\"vm.toggle()\"> <span>{{ vm.title }}</span> <i class=\"fa fa-chevron-right\" ng-class=\"{'show': vm.show}\" aria-hidden=\"true\"></i> </h3> <ng-transclude ng-if=\"vm.show\"></ng-transclude> </div> ";
// Exports
module.exports = code;